<template>
    <div>
        <v-menu right nudge-right="45" min-width="152" z-index="1000" :close-on-content-click="false">
            <v-avatar size="36" class="white--text avatar_customer primary" :class="statusCurrentBot ? 'online' : 'offline'" slot="activator"  v-if="user && user.email">
                {{$AppService.createTextImage(user.name ? user.name : user.email)}}
            </v-avatar>
            <img src="/icon/setting.svg" alt="settings icon" v-else
                 style="vertical-align: middle; cursor: pointer" slot="activator"/>
            <v-list v-if="user && user.email">
                <v-list-tile>
                    <v-list-tile-content>
                        <v-list-tile-title>{{ user.name ? user.name : user.email.split('@')[0]}}
                        </v-list-tile-title>
                        <v-list-tile-sub-title>{{ user.email }}</v-list-tile-sub-title>
                    </v-list-tile-content>
                </v-list-tile>
                <v-divider></v-divider>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title>{{$t('notification') | capitalize}}</v-list-tile-title>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <v-btn icon @click="disableNotify" v-if="isEnableNotify">
                      <v-icon color="#9A9A9A">mdi-bell-outline</v-icon>
                    </v-btn>
                    <v-btn icon @click="enableNotify" v-else>
                      <v-icon color="#9A9A9A">mdi-bell-off-outline</v-icon>
                    </v-btn>
                  </v-list-tile-action>
                </v-list-tile>
                <v-list-tile>
                    <v-list-tile-content>
                        <v-list-tile-title class="sub_menu_button">{{$t('receiveAutoAssign')|capitalize}}</v-list-tile-title>
                    </v-list-tile-content>
                    <v-list-tile-action>
                        <v-spacer/>
                        <v-switch v-on:change="updateStatusCurrentBot" v-model="statusCurrentBot" color="success"/>
                    </v-list-tile-action>
                </v-list-tile>
<!--                <v-list-tile v-on:click.stop.prevent="statusAllBot = !statusAllBot" v-if="userConfig['allowConfigBotHasRole']">-->
<!--                    <v-list-tile-content>-->
<!--                        <v-list-tile-title class="sub_menu_button">{{$t('receiveAutoAssignAllBot')|capitalize}}</v-list-tile-title>-->
<!--                    </v-list-tile-content>-->
<!--                    <v-list-tile-action>-->
<!--                        <v-spacer/>-->
<!--                        <v-switch v-model="statusAllBot" color="success" v-on:click.prevent/>-->
<!--                    </v-list-tile-action>-->
<!--                </v-list-tile>-->
                <v-list-tile v-if="!isOutsourceSupporter()" v-on:click="toStatistic">
                    <v-list-tile-title class="sub_menu_button">{{$t('kpi')}}</v-list-tile-title>
                </v-list-tile>
                <v-list-tile v-if="isShowAdminMenu()" v-on:click="toSessionReport">
                    <v-list-tile-title class="sub_menu_button">{{$t('sessionReport')}}</v-list-tile-title>
                </v-list-tile>
                <v-list-tile v-if="isShowAdminMenu()" v-on:click="toSenderReport">
                    <v-list-tile-title class="sub_menu_button">{{$t('senderList')}}</v-list-tile-title>
                </v-list-tile>
                <v-list-tile v-if="isShowAdminMenu() && botConfig['allowOverviewReport']" v-on:click="toOverviewReport">
                    <v-list-tile-title class="sub_menu_button">{{$t('overviewReport.title')}}</v-list-tile-title>
                </v-list-tile>
                <v-list-tile v-if="isShowAdminMenu() && botConfig['allowReportCategories']" v-on:click="toConversationTypesReport">
                    <v-list-tile-title class="sub_menu_button">{{$t('conversationTypesReport') | capitalize}}</v-list-tile-title>
                </v-list-tile>
                <v-list-tile v-if="isShowAdminMenu()" v-on:click="toNLP">
                    <v-list-tile-title class="sub_menu_button">{{$t('nlp')| capitalize}}</v-list-tile-title>
                </v-list-tile>
                <v-list-tile v-if="isShowAdminMenu()" v-on:click="toTicketManagement">
                    <v-list-tile-title class="sub_menu_button">{{$t('ticketManagement')| capitalize}}</v-list-tile-title>
                </v-list-tile>
                <v-list-tile v-if="isShowAdminMenu()" v-on:click="toScenario">
                    <v-list-tile-title class="sub_menu_button">{{$t('scenario')|capitalize}}</v-list-tile-title>
                </v-list-tile>
                <v-list-tile v-if="isShowAdminMenu()" v-on:click="toRatingReport">
                  <v-list-tile-title class="sub_menu_button">{{$t('ratingReport')|capitalize}}</v-list-tile-title>
                </v-list-tile>
                <v-list-tile v-if="isShowAdminMenu() && botConfig['enableOverviewDashboardRealtime']" v-on:click="toDashBoardRealtime">
                  <v-list-tile-title class="sub_menu_button">{{$t('dashboardRealtime')|capitalize}}</v-list-tile-title>
                </v-list-tile>
                <v-list-tile v-if="isShowAdminMenu() && botConfig['enableOverviewDashboard']" v-on:click="toDashBoard">
                  <v-list-tile-title class="sub_menu_button">{{$t('dashboard')|capitalize}}</v-list-tile-title>
                </v-list-tile>
                <v-list-tile v-if="isShowAdminMenu() && bot_allow_sla_monitor==='1'" v-on:click="toSLAReport">
                    <v-list-tile-title class="sub_menu_button">{{$t('SLAReport')|capitalize}}</v-list-tile-title>
                </v-list-tile>
                <v-list-tile v-if="isShowAdminMenu() && botConfig['allowAgentMonitor']" v-on:click="toAgentMonitor">
                    <v-list-tile-title class="sub_menu_button">{{$t('agentMonitor.title')|capitalize}}</v-list-tile-title>
                </v-list-tile>

                <v-list-tile v-on:click="toSettings">
                    <v-list-tile-title class="sub_menu_button">{{$t('settings')|capitalize}}</v-list-tile-title>
                </v-list-tile>
                <v-list-tile v-on:click="openLanguage">
                    <v-list-tile-title class="sub_menu_button">{{$t('language')|capitalize}}</v-list-tile-title>
                </v-list-tile>
                <v-list-tile v-on:click="signOut">
                    <v-list-tile-title class="sub_menu_button">{{$t('signOut')|capitalize}}</v-list-tile-title>
                </v-list-tile>
            </v-list>
            <span style="
                font-size: 11px;
                color: #bbb;
                display: block;
                width: 100%;
                padding: 0 15px 2px;
                text-align: right;
                background-color: #fff;
            ">v3.5.123</span>
        </v-menu>
        <LanguageMenu ref="LanguageMenu"></LanguageMenu>
    </div>

</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";
import LanguageMenu from "./LanguageMenu";
import StaffService from "@/services/staff.service";
import {mapFields} from "vuex-map-fields";
import {storage} from "../../utils/map";
import $const from "../../utils/const";

const botHost = process.env.VUE_APP_FPTAI_BOT_HOST;
    export default {
        name: "Menu",
        components: { LanguageMenu },
        props: {
            user: Object,
            bot_allow_sla_monitor: {
                type: String,
                default:'0'
            }
        },
        data() {
            return {
                icons: {settings: require('assets/icons/settings.svg')},
                autoAssignStatusAllBot: false,
                autoAssignStatusCurrentBot: false
            };
        },
        computed: {
            ...mapState(['bot', 'botStaffList', 'updateAutoAssignConfig']),
            ...mapState('config', ['botConfig', 'userConfig']),
            ...mapFields('autoAssign', ['statusAllBot', 'statusCurrentBot']),
            ...mapGetters('config', ['isEnableNotify'])
        },
        methods: {
            ...mapActions('autoAssign', ['updateStatusAllBot', 'updateStatusCurrentBot']),
            ...mapActions('auth', ['signOut']),
            ...mapActions('config', ['enableNotify', 'disableNotify']),
            toNLP() {
                const provider = JSON.parse(storage.getItem($const.LOCAL_STORAGE_KEY.PROVIDER))
                window.open(`${botHost}/login-default/${provider.name}/?next=/bot/${this.$route.params.bot_code}/nlp/sample`, '_blank');
            },
            toScenario() {
              const provider = JSON.parse(storage.getItem($const.LOCAL_STORAGE_KEY.PROVIDER))
              window.open(`${botHost}/login-default/${provider.name}/?next=/bot/${this.$route.params.bot_code}/dm/`, '_blank');
            },
            toRatingReport() {
              this.$router.push('/rating-report/' + this.$route.params.bot_code);
            },
            toSettings() {
                this.$router.push('/settings/' + this.$route.params.bot_code);
            },
            isOutsourceSupporter() {
                return !StaffService.checkStaffHasRoleFeature(this.$route.params.bot_code, this.user.id, $const.ROLE_FEATURES.ACCESS_LIVE_SUPPORT_PAGE)
            },
            isShowAdminMenu() {
                return StaffService.checkStaffHasRole(this.bot.code, this.user.id, [10, 9, 5]);
            },
            toStatistic() {
                this.$router.push('/statistic/' + this.$route.params.bot_code);
            },
            toSessionReport() {
                this.$router.push('/session-info/' + this.$route.params.bot_code);
            },
            toSenderReport() {
                this.$router.push('/sender/' + this.$route.params.bot_code);
            },
            toOverviewReport() {
                this.$router.push(`/overview-report/${this.$route.params.bot_code}/`);
            },
            toTicketManagement() {
                this.$router.push('/ticket-management/' + this.$route.params.bot_code)
            },
            toConversationTypesReport() {
                this.$router.push(`/bot/${this.$route.params.bot_code}/conversation-types-report`);
            },
            toCategoriesReport() {
                this.$router.push('/report-categories/' + this.$route.params.bot_code);
            },
            toDashBoard() {
                this.$router.push(`/dashboard/${this.$route.params.bot_code}`)
            },
            toDashBoardRealtime() {
              this.$router.push(`/dashboard-realtime/${this.$route.params.bot_code}`)
            },
            openLanguage() {
                this.$refs.LanguageMenu.open()
            },
            toAgentMonitor(){
                this.$router.push('/agent-monitor/' + this.$route.params.bot_code);
            },

            toSLAReport(){
                this.$router.push('/sla-report/' + this.$route.params.bot_code);
            },


        },
      watch: {
        // statusAllBot(newVal, oldVal) {
        //   if (oldVal !== null && newVal !== null) {
        //     this.updateStatusAllBot()
        //   }
        // }
      }
    }
</script>

<style scoped lang="scss">
    .avatar_customer {
        position: relative;

        &:after {
             content: '';
             width: 12px;
             height: 12px;
             border-radius: 50%;
             background: transparent;
             position: absolute;
             right: 0;
             bottom: 0;
             border: thin solid white;
         }

        &.online:after {
            background: #19AA66;
        }
        &.offline:after {
            background: #888A9A;
        }
    }
</style>
